export default __webpack_public_path__ + "static/748-9b495871e3bc4b9bcadbd1e1b9e93721.gif";